import publicRoutes from "./routes";

export default publicRoutes;
